import React, { useEffect, useState } from 'react';
import { FaDownload, FaTimes } from 'react-icons/fa';
import './PWAInstallPrompt.scss';

const DISMISS_KEY = 'mivent_pwa_install_dismissed';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstalled, setIsInstalled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    if (isStandalone) {
      setIsInstalled(true);
      return;
    }

    const dismissed = localStorage.getItem(DISMISS_KEY) === 'true';

    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
      if (!dismissed) {
        setIsVisible(true);
      }
    };

    const onAppInstalled = () => {
      setIsInstalled(true);
      setIsVisible(false);
      setDeferredPrompt(null);
      localStorage.removeItem(DISMISS_KEY);
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    window.addEventListener('appinstalled', onAppInstalled);

    return () => {
      window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
      window.removeEventListener('appinstalled', onAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult?.outcome === 'accepted') {
      setIsVisible(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem(DISMISS_KEY, 'true');
  };

  if (!isVisible || isInstalled) return null;

  return (
    <div className="pwa-install-banner" role="dialog" aria-label="Install app banner">
      <div className="pwa-install-banner__content">
        <h4>Install MIVENT App</h4>
        <p>Get faster launches and a full-screen app experience.</p>
      </div>
      <div className="pwa-install-banner__actions">
        <button type="button" className="pwa-install-banner__install" onClick={handleInstall}>
          <FaDownload /> Install
        </button>
        <button
          type="button"
          className="pwa-install-banner__dismiss"
          onClick={handleDismiss}
          aria-label="Dismiss install suggestion"
        >
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
